import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  HttpEvent,
  HttpParams,
  HttpRequest,
  HttpClient,
  HttpEventType,
  HttpResponse,
  HttpHeaders
} from "@angular/common/http";
import { LoopBackAuth } from "src/providers/sdk";

@Injectable({
  providedIn: "root"
})
export class UploadService {
  // file from event.target.files[0]
  private upload(url: string, file: File): Observable<HttpEvent<any>> {
    let formData = new FormData();
    formData.append("upload", file);

    let params = new HttpParams();
    let headers = new HttpHeaders({
      Authorization: this.auth.getAccessTokenId()
    });
    const options = {
      headers: headers,
      params: params,
      reportProgress: true
    };

    const req = new HttpRequest("POST", url, formData, options);
    const observable = this.http.request(req);

    return observable;
  }

  async uploadFiles(files: FileList) {
    if (files.length == 0) {
      console.log("No file selected!");
      return;
    }
    let file: File = files[0];

    return new Promise((resolve, reject) => {
      this.upload(this.uploadUrl, file).subscribe(
        event => {
          if (event.type == HttpEventType.UploadProgress) {
            const percentDone = Math.round((100 * event.loaded) / event.total);
          } else if (event instanceof HttpResponse) {
          }
        },
        err => {
          console.log("Upload Error:", err);
        },
        () => {
          console.log("Upload done");
          resolve("myresult");
        }
      );
    });
  }

  uploadUrl = "https://smartedafrica.herokuapp.com/api/medias/upload";

  constructor(private http: HttpClient, private auth: LoopBackAuth) {}
}
